'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactTextareaAutosize = require('react-textarea-autosize');

var _reactTextareaAutosize2 = _interopRequireDefault(_reactTextareaAutosize);

var _reactDom = require('react-dom');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactOnclickout = require('react-onclickout');

var _reactOnclickout2 = _interopRequireDefault(_reactOnclickout);

var _is = require('is');

var _is2 = _interopRequireDefault(_is);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _raf = require('raf');

var _raf2 = _interopRequireDefault(_raf);

var _textWidth = require('text-width');

var _textWidth2 = _interopRequireDefault(_textWidth);

var _utils = require('utils/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* injects from baggage-loader */
var styles = require('./EditableTextArea.pcss');

//TODO fix font loading bug
var measureLine = function measureLine(line) {
  return Math.ceil((0, _textWidth2.default)(line, { family: 'sans-serif', size: 14 })) + 1;
};

var measureWidth = function measureWidth(text) {
  return text.split('\n').map(measureLine).reduce(function (a, b) {
    return Math.max(a, b);
  }, 0);
};

var EditableTextArea = (_temp = _class = function (_Component) {
  _inherits(EditableTextArea, _Component);

  _createClass(EditableTextArea, [{
    key: 'startEdit',
    value: function startEdit() {
      if (this) {
        this.handleEditStart();
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.textAreaNode = (0, _reactDom.findDOMNode)(this.refs.textArea);
    }
  }]);

  function EditableTextArea(props) {
    _classCallCheck(this, EditableTextArea);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(EditableTextArea).call(this, props));

    _this.state = { editing: false, editValue: '' };
    return _this;
  }

  _createClass(EditableTextArea, [{
    key: 'handleEditStart',
    value: function handleEditStart(ev) {
      var _this2 = this;

      if (ev) ev.stopPropagation();

      var disabled = this.props.disabled;

      if (disabled) return;

      this.setState({ editing: true, editValue: this.props.text });
      this.props.onEditStart();

      (0, _raf2.default)(function () {
        _this2.textAreaNode.focus();
        _this2.textAreaNode.select();
      });
    }
  }, {
    key: 'handleEditSubmit',
    value: function handleEditSubmit() {
      var editValue = this.state.editValue;

      this.props.onEditSubmit(editValue);
      this.setState({ editing: false });
    }
  }, {
    key: 'handleChange',
    value: function handleChange(ev) {
      var editValue = ev.target.value;
      this.setState({ editValue: editValue });
      this.props.onEditChange(editValue);
    }
  }, {
    key: 'handleKeyUp',
    value: function handleKeyUp(e) {
      if (e.keyCode === 27) this.handleEditSubmit();
    }
  }, {
    key: 'handleClickOut',
    value: function handleClickOut() {
      if (this.isEditing()) this.handleEditSubmit();
    }
  }, {
    key: 'getWidth',
    value: function getWidth() {
      var editValue = this.state.editValue;
      var _props = this.props;
      var text = _props.text;
      var maxWidth = _props.maxWidth;
      var minWidth = _props.minWidth;


      var measured = this.isEditing() ? editValue : text;
      return (0, _utils.padNumber)({ x: measureWidth(measured), min: minWidth, max: maxWidth });
    }
  }, {
    key: 'isEditing',
    value: function isEditing() {
      if (_is2.default.defined(this.props.editing)) return this.props.editing;

      return this.state.editing;
    }
  }, {
    key: 'render',
    value: function render() {
      var width = this.getWidth();

      var editing = this.isEditing();

      var classname = (0, _classnames2.default)(styles.container, editing && styles.editing, this.props.disabled && styles.disabled, this.props.dark && styles.dark);

      return _react2.default.createElement(
        _reactOnclickout2.default,
        { onClickOut: this.handleClickOut.bind(this) },
        _react2.default.createElement(
          'div',
          {
            style: { width: width },
            className: classname
          },
          _react2.default.createElement(_reactTextareaAutosize2.default, {
            style: { width: width },
            ref: 'textArea',
            onBlur: this.handleEditSubmit.bind(this),
            onKeyUp: this.handleKeyUp.bind(this),
            onClick: function onClick(ev) {
              return ev.stopPropagation();
            },

            className: styles.textArea,
            value: this.state.editValue,
            onChange: this.handleChange.bind(this)
          }),
          _react2.default.createElement(
            'span',
            {
              style: { width: width },
              className: styles.content
            },
            this.props.text
          )
        )
      );
    }
  }]);

  return EditableTextArea;
}(_react.Component), _class.defaultProps = {
  minWidth: 40,
  onEditStart: _lodash2.default.noop,
  onEditSubmit: _lodash2.default.noop,
  onEditCancel: _lodash2.default.noop,
  onEditChange: _lodash2.default.noop
}, _temp);
exports.default = EditableTextArea;


EditableTextArea.propTypes = {
  customWidth: _react.PropTypes.number,
  text: _react.PropTypes.string.isRequired,
  dark: _react.PropTypes.bool,

  onEditStart: _react.PropTypes.func,
  onEditChange: _react.PropTypes.func,
  onEditSubmit: _react.PropTypes.func,
  onEditCancel: _react.PropTypes.func,

  editing: _react.PropTypes.bool, // controlled mode

  disabled: _react.PropTypes.bool
};


//////////////////
// WEBPACK FOOTER
// ./app/components/Common/EditableTextArea.js
// module id = 552
// module chunks = 1